import assert from 'assert';
import stoplight from './stoplight';
import * as r from 'ramda';

export const serviceFactoryFactory = ({ log }) => (config) => {
  assert(config.name, "service config: must include name for service (used in error reporting)");
  assert(config.subscribe, "service config: must provide subscribe(update) function");
  assert(config.subscribe.constructor.name !== "AsyncFunction", "service config: subscribe(update) must not be async")

  var current;
  var unsubscribe;
  var listeners = [];

  const service = {
    get: async () => {
      const light = stoplight();
      const unsub = service.subscribe(v => {
        if (v._refreshing === false) light.go(v);
      });
      const value = await light.ok();
      unsub()
      return value;
    },

    subscribe: (cb) => {

      if (listeners.length === 0) {
        current = Object.assign({}, current, { _refreshing: true, _service: service });
        if (config.debug) log(config.name + " resubscribing ");
        unsubscribe = config.subscribe((value, refreshing = false) => {
          var old = current;
          current = Object.assign({}, config.initial, current, value, { _service: service, _refreshing: refreshing })
          if (config.debug) log(config.name + " update ", current);
          listeners.forEach(fn => log.handle('service-update: ' + config.name, () => fn(current, old)))
        })
      }

      listeners.push(cb);
      if (config.debug) log(config.name + " initial update ", current);
      cb(current);

      return () => {
        listeners = r.without([cb], listeners);
        if (listeners.length === 0 && unsubscribe) {
          if (config.debug) log(config.name + " unsubscribing");
          return unsubscribe();
        }
      }
    }

  }
  return service;
};

export const refresh = async (update, getter, timeout = 250) => {
  const timer = setTimeout(() => update({}, true), timeout);
  const value = await getter();
  clearTimeout(timer);
  return update(value);
}

export default serviceFactoryFactory;


// WEBPACK FOOTER //
// ./src/api/service-factory.js